// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__xRHwJ","additionalInfo":"AgreementModal_additionalInfo__1uuYF"};